import { render, staticRenderFns } from "./InterestType.vue?vue&type=template&id=3382e325"
import script from "./InterestType.vue?vue&type=script&lang=js"
export * from "./InterestType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports